import React, { useState } from 'react'
import { useEffect } from 'react'
import './index.less'
import { getDynastyDistribution } from '@/server'
import * as echarts from 'echarts'
import { useAppSelector } from '@/hooks'
const classC2E = {
  作者: 'author',
  画作: 'work',
  主题: 'class1',
  技法: 'class2',
  画幅: 'styleType',
  年代精度: 'year'
}
const colorArr = ['#6f7ca7', '#a3ac8e', '#bbc5cb', '#c7c9c0', '#9c6970', '#535876']

export function DynastyDistribution() {
  const token = useAppSelector((state) => state.login.token)
  // 当前分类指标
  const [classKey, setClassKey] = useState('author')
  // 原数据
  const [rawData, setRawData] = useState<any[]>([])
  // echarts配置
  const [option, setOption] = useState<any>({})
  // 切换class获取数据
  useEffect(() => {
    getDynastyDistribution({ key: classKey }, token).then((res) => {
      setRawData([...res.data.content])
    })
  }, [classKey])
  // 监听数据变化，配置option
  useEffect(() => {
    let tempOption: any = {}
    let handledData: any[] = []
    let tempSeriesData: any[] = []

    if (rawData.length > 0) {
      // 堆叠bar
      if (Object.keys(rawData[0]).length > 2) {
        tempSeriesData = []
        handledData = Array.from(new Set(rawData.map((d) => d.dynasty))).map((d) => {
          return { dynasty: d }
        })
        rawData.forEach((item) => {
          handledData.forEach((d) => {
            if (item.dynasty === d.dynasty) {
              d[item.name] = item.num
            }
            tempSeriesData.push(item.name)
          })
        })
        tempSeriesData = Array.from(new Set(tempSeriesData)).map((d, i) => {
          return {
            name: d,
            type: 'bar',
            stack: 'num',
            emphasis: {
              focus: 'series'
            },
            data: handledData.map((item) => item[d] ?? 0),
            itemStyle: {
              color: colorArr[i % colorArr.length]
            }
          }
        })
      } else {
        handledData = rawData
        tempSeriesData = [
          {
            name: '数量',
            type: 'bar',
            stack: 'num',
            emphasis: {
              focus: 'series'
            },
            data: handledData.map((d) => d.num),
            itemStyle: {
              color: colorArr[0]
            }
          }
        ]
      }
      tempOption = {
        animation: false,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: { right: '4%', top: '10px' },
        grid: {
          top: '30px',
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [...handledData.map((d) => d.dynasty)]
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: JSON.parse(JSON.stringify(tempSeriesData)),
        barWidth: 55
      }
      const deepClone = JSON.parse(JSON.stringify(tempOption))
      setOption(deepClone)
    }
  }, [rawData])
  // 监听配置变化，重新渲染图表
  useEffect(() => {
    drawChart()
  }, [option])
  function drawChart() {
    const chartDom: HTMLElement | null = document.getElementById(
      'dynasty-distribution-chart-container'
    )
    const myChart = chartDom && echarts.init(chartDom)
    //@ts-ignore
    // setOption(option, notMerge),第二个参数须为true,否则合并上一次渲染数据
    if (option) {
      myChart?.setOption(JSON.parse(JSON.stringify(option)), true)
    }
    // 自适应
    window.addEventListener('resize', () => {
      myChart?.resize()
    })
  }
  return (
    <>
      <div className='dynasty-distribution-container' id='dynasty-distribution-container'>
        <div className='class-select-container'>
          {Object.keys(classC2E).map((d) => (
            <div
              className={
                classC2E[d] === classKey ? 'class-button class-button-selected' : 'class-button'
              }
              onClick={() => setClassKey(classC2E[d])}
            >
              {d}
            </div>
          ))}
        </div>
        <div
          className='dynasty-distribution-chart-container'
          id='dynasty-distribution-chart-container'
        ></div>
      </div>
    </>
  )
}
